const SubAbasProdutosDaf = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/produtosdaf/produtos/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasProdutosDaf;
